import { render, staticRenderFns } from "./StepsSection.vue?vue&type=template&id=30aafc4a&"
import script from "./StepsSection.vue?vue&type=script&lang=js&"
export * from "./StepsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports